export const  personalProjectsItems = [
    {
        title: "HAWKR Restaurant Website",
        subheading: "E-Commerce/Marketing",
        image: [
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/clientProjects/hawkrMenuApp/hawkrImg1.png",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/clientProjects/hawkrMenuApp/hawkrImg2.png",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/clientProjects/hawkrMenuApp/hawkrImg3.png",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/clientProjects/hawkrMenuApp/hawkrImg4.png"
        ],
        desc: [
            "A website that aims to increase customer engagement of my cousin's Philippine-based restaurant by providing essential details. ",
            "Users are able to view the menu, contact the restaurant and view business goals and achievements in a centralized location."
        ],
        skills: ["React.JS", "AWS S3"],
        rep: "https://github.com/oreoolis/HAWKR-Menu",
        website: "https://hawkr-menu.vercel.app"
    }
];